import { AjaxResponse } from 'rxjs/ajax';
import { HTTP_SUCCESS_CODES_RANGE } from '../constants';

export const isRequestFailed = (ajaxResponse: AjaxResponse): boolean => {
  return ajaxResponse.status < HTTP_SUCCESS_CODES_RANGE[0] || ajaxResponse.status > HTTP_SUCCESS_CODES_RANGE[1];
};
